export default {
    title: 'Πρότυπα σημειώσεων',
    subtitle: 'Δες και επεξεργάσου τα πρότυπα σημειώσεών σου',
    add: 'Προσθήκη νέου',
    name: 'Όνομα προτύπου',
    searchPlaceholder: 'Αναζήτηση προτύπου...',
    empty: {
        title: 'Δεν έχεις πρότυπα σημειώσεων ακόμα',
        subtitle: 'Φτιάξε ένα πρότυπο για να γράφεις σημειώσεις πιο γρήγορα.',
        noMatch: 'Δεν βρέθηκαν πρότυπα'
    },
    edit: {
        pageTitle: 'Επεξεργασία σημειώσεων',
        title: 'Σημειώσεις διατροφικού πλάνου',
        subtitle: 'Πληκτρολόγησε σημειώσεις προς εκτύπωση με τα διατροφικά σου πλάνα.',
        createNew: 'Δημιουργία νέου προτύπου',
    }
}